import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import { insertIf } from '../../../helpers/common'
import { getIsBudgetAllocationType } from '../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'

import { getLineItems } from '../../../modules/actions/lineItems'
import { selfAccountSelector } from '../../../modules/selectors/selfAccounts'
import { rightSelector } from '../../../modules/selectors/rights'

import { GAM_NETWORK_CODE } from '../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'
import { GOOGLE_AD_MANAGER_PLATFORM } from '../../../constants/selectLists/platformList'
import { ENVIRONMENT_TYPE } from './UploadGamAdCreativeForm/LineItemForm/fields'

export const useFetchLineItemsHandler = ({ rightCampaignsToLoadIds }) => {
  const dispatch = useDispatch()
  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const right = useSelector(rightSelector)
  const isBudgetAllocationType = getIsBudgetAllocationType(right)

  return useCallback(() => {
    const fields = [
      'targeting',
      'date_start',
      'date_stop',
      'primary_goal',
      'order_id',
      ENVIRONMENT_TYPE,
      // we need to fetch cost_per_unit only for budget allocation type
      // to be able to calculate remaining budget based on cost_per_unit.micro_amount
      ...insertIf(isBudgetAllocationType, 'cost_per_unit')
    ]

    // We need to fetch existing line items either for showing existing line items in the dropdown
    // OR for validation of overlapping targeting
    dispatch(
      getLineItems(
        {
          network_code: gamNetworkCode,
          order_ids: rightCampaignsToLoadIds.join(','),
          fields: fields.join(', ')
        },
        GOOGLE_AD_MANAGER_PLATFORM
      )
    )
  }, [dispatch, isBudgetAllocationType, gamNetworkCode, rightCampaignsToLoadIds])
}
